import { useFieldArray, UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { FormValues } from './AnnuityPurchase.meta';

export type PurchasesFieldArray = UseFieldArrayReturn<FormValues, 'Purchases', 'key'>;

export const usePurchasesFieldArray = (): PurchasesFieldArray => {
  const formBag = useFormContext<FormValues>();

  const fieldName = 'Purchases';

  const fieldArrayBag = useFieldArray({
    control: formBag.control,
    name: fieldName,
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch(fieldName);
  const controlledFields = watchFieldArray
    ? fieldArrayBag.fields.map((field, index) => {
        return {
          ...field,
          ...watchFieldArray[index],
        };
      })
    : [];

  return {
    ...fieldArrayBag,
    fields: controlledFields,
  };
};
